import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
const { colors, devices, fontSizes, spaces } = theme;

const StyledBannerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  align-items: center;
  max-width: ${spaces.large24X * 10 + 80}px;
  padding-top: ${spaces.large12X - 2}px;
  padding-bottom: ${spaces.large24X}px;

  @media ${devices.tablet} {
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
    padding-top: ${spaces.regular}px;
    padding-bottom: ${spaces.regular}px;
  }
`;

const StyledBannerImageContainer = styled.div`
  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `}
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const StyledBannerContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${devices.tablet} {
    padding-right: 0;
    width: 100%;
  }
`;

const StyledBannerHeaderSection = styled.div`
  margin-bottom: ${spaces.large2X - 2}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.large11X}px;
  font-weight: 500;
  color: ${colors.gray[800]};
  text-align: center;
  @media ${devices.tablet} {
    font-size: ${fontSizes.large2X}px;
    margin-bottom: ${spaces.large}px;
  }
`;
const StyledBannerSubHeaderSection = styled.div`
  margin-bottom: ${spaces.large9X}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.large}px;
  font-weight: 400;
  color: ${colors.gray[700]};
  text-align: center;
  @media ${devices.tablet} {
    font-size: ${fontSizes.regular}px;
    margin-bottom: ${spaces.large3X}px;
  }
`;

const AboutBannerSection = ({ imgSrc, header, subHeader }) => {
  return (
    <StyledBannerContainer>
      <StyledBannerContentContainer>
        <StyledBannerHeaderSection>{header}</StyledBannerHeaderSection>
        {subHeader && (
          <StyledBannerSubHeaderSection>
            {subHeader}
          </StyledBannerSubHeaderSection>
        )}
      </StyledBannerContentContainer>
      <StyledBannerImageContainer>
        <picture>
          <source srcSet={imgSrc} type="image/png" />
          <img src={imgSrc} alt="Banner image" />
        </picture>
      </StyledBannerImageContainer>
    </StyledBannerContainer>
  );
};

AboutBannerSection.propTypes = {
  imgSrc: PropTypes.string,
  header: PropTypes.node,
  subHeader: PropTypes.node,
};

export default AboutBannerSection;
